import { render, staticRenderFns } from "./ComponentQrPopup.vue?vue&type=template&id=3c351256&"
import script from "./ComponentQrPopup.vue?vue&type=script&lang=ts&"
export * from "./ComponentQrPopup.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentQrPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports